import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-display-cards',
  templateUrl: './display-cards.component.html',
  styleUrl: './display-cards.component.scss'
})
export class DisplayCardsComponent {
  @Input() cardData: { title: string; content: string }[] = [];

}
